import {Component} from "@angular/core";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";


@Component({
    selector: 'db-reset-password-success',
    templateUrl: 'reset-password-success.component.html',
    styleUrls: ['reset-password-success.component.scss'],
    standalone: false
})
export class ResetPasswordSuccessComponent extends DialogComponent<null, boolean> {

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    super(
      _dialogService
    );

  }

  public closeDialog(): void {
    this._store.dispatch(new fromStore.LoadUser());
    this.close();
  }


}
